import styled from "styled-components";

export const StartButton = styled.button`
  background: #eb7c00;
  border: none;
  border-radius: 25px;
  padding: 0.5rem;
`;

export const TabButton = styled.button`
  background: #101e8e;
  color: white;
  padding: 0.7rem;
  position: relative;
  border: none;
`;

export const DELINK = styled.button`
  border: 1px solid #101e8e;
  background: transparent;
  color: #101e8e;
  padding: 0.6rem;
  transition: ease-in-out 0.3s;
  cursor: pointer;
  &:hover {
    color: white;
    background: #101e8e;
  }
`;
